import { AutocompleteFaqsStandalone } from '@/components/molecules/AutocompleteFaqs';
import { loadCarousels } from '@/utils/Controllers/CarouselController';

document.addEventListener('DOMContentLoaded', () => {
  AutocompleteFaqsStandalone();
  loadCarousels();
});
